import { Grid, Heading, Text, useTheme } from '@simplywallst/ui-core';

const WelcomeStep = () => {
  const theme = useTheme();
  return (
    <Grid gap={`${theme.x3}px`}>
      <Grid gap={`${theme.x1}px`}>
        <Heading as={'h1'} color="brand01" typography="xLargeStrong">
          Welcome to Narratives
        </Heading>
        <Text typography="small" color="whiteRGBA" opacity={0.7}>
          Capture your perspective and always know what you own, and why you own
          it.
        </Text>
      </Grid>
      <Grid gap={`${theme.x0_5}px`}>
        <Text typography="largeStrong">Your story</Text>
        <Text typography="small" color="whiteRGBA" opacity={0.7}>
          Capture your outlook on how this stock in positioned for the future.
        </Text>
      </Grid>
      <Grid gap={`${theme.x0_5}px`}>
        <Text typography="largeStrong">Forecast your assumptions</Text>
        <Text typography="small" color="whiteRGBA" opacity={0.7}>
          Capture how you assume catalysts will impact the business modal, like
          revenue & earnings.
        </Text>
      </Grid>
      <Grid gap={`${theme.x0_5}px`}>
        <Text typography="largeStrong">Calculate Fair Value</Text>
        <Text typography="small" color="whiteRGBA" opacity={0.7}>
          Know what a fair price is based on your perspective. Know when to buy
          and when to consider selling.
        </Text>
      </Grid>
    </Grid>
  );
};
export default WelcomeStep;
